/* eslint-disable no-undef */
(function () {
  'use strict';

  window.OletLens = window.OletLens || {};

  var CENTS_MULTIPLIER = 100;

  function getActiveCurrency() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
  }

  function getConversionRate() {
    return (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate)
      ? parseFloat(window.Shopify.currency.rate)
      : 1;
  }

  function convertFromUSD(usdAmount) {
    return usdAmount * getConversionRate();
  }

  function getMoneyFormat() {
    var metaTag = document.querySelector('meta[name="money-format"]');
    if (metaTag) return decodeURIComponent(metaTag.getAttribute('content') || '');

    if (window.money_format) return window.money_format;
    if (window.Shopify && window.Shopify.money_format) return window.Shopify.money_format;

    return '${{amount}}';
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) return '0';
    var fixed = number.toFixed(precision);
    var parts = fixed.split('.');
    var integer = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
    return precision > 0 ? integer + decimal + parts[1] : integer;
  }

  function formatMoneyManual(cents, format) {
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var match = format.match(placeholderRegex);

    if (!match) return '$' + (cents / 100).toFixed(2);

    switch (match[1]) {
      case 'amount':
        value = formatWithDelimiters(cents / 100, 2, ',', '.');
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(Math.round(cents / 100), 0, ',', '.');
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents / 100, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(Math.round(cents / 100), 0, '.', ',');
        break;
      default:
        value = (cents / 100).toFixed(2);
    }

    return format.replace(placeholderRegex, value);
  }

  function formatMoney(amount) {
    var amountInCents = Math.round(amount * CENTS_MULTIPLIER);

    if (window.Currency && typeof window.Currency.formatMoney === 'function') {
      var moneyFormat = getMoneyFormat();
      return window.Currency.formatMoney(amountInCents, moneyFormat);
    }

    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(amountInCents, getMoneyFormat());
    }

    var format = getMoneyFormat();
    if (format) {
      return formatMoneyManual(amountInCents, format);
    }

    var currency = getActiveCurrency();
    return amount.toFixed(2) + ' ' + currency;
  }

  function formatPrice(usdAmount) {
    if (usdAmount === 0) return formatMoney(0);
    var converted = convertFromUSD(usdAmount);
    return formatMoney(converted);
  }

  function onCurrencyChange(callback) {
    document.addEventListener('currency:updated', function () {
      if (typeof callback === 'function') callback(getActiveCurrency());
    });

    document.addEventListener('shopify:currency:changed', function () {
      if (typeof callback === 'function') callback(getActiveCurrency());
    });

    var lastCurrency = getActiveCurrency();
    setInterval(function () {
      var current = getActiveCurrency();
      if (current !== lastCurrency) {
        lastCurrency = current;
        if (typeof callback === 'function') callback(current);
      }
    }, 800);
  }

  window.OletLens.Currency = {
    formatPrice: formatPrice,
    formatMoney: formatMoney,
    convertFromUSD: convertFromUSD,
    getActiveCurrency: getActiveCurrency,
    getConversionRate: getConversionRate,
    onCurrencyChange: onCurrencyChange,
  };
})();

